export interface Padding {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

export var SVG_NS = 'http://www.w3.org/2000/svg';

/**
 * Attaches RAF-throttled hover listeners (mouse + touch + resize).
 * Each chart provides its own onUpdate(mx, my) and onLeave() callbacks.
 */
export function attachHoverListeners(
  container: HTMLElement,
  svgEl: SVGSVGElement,
  onUpdate: (mx: number, my: number) => void,
  onLeave: () => void
): void {
  var rafPending = false;
  var lastCX = 0, lastCY = 0;

  function schedule() {
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        var r = svgEl.getBoundingClientRect();
        onUpdate(lastCX - r.left, lastCY - r.top);
      });
    }
  }

  container.addEventListener('mousemove', function (e: MouseEvent) {
    lastCX = e.clientX; lastCY = e.clientY;
    schedule();
  }, { passive: true });

  container.addEventListener('mouseleave', onLeave, { passive: true });

  container.addEventListener('touchmove', function (e: TouchEvent) {
    var t = e.touches[0];
    lastCX = t.clientX; lastCY = t.clientY;
    schedule();
  }, { passive: true });

  container.addEventListener('touchend', onLeave, { passive: true });
}

/**
 * Watches the container's parent for width changes and re-renders the chart.
 * Disconnects before re-render to prevent loops (render sets fixed width).
 * The re-render will call observeResize again, keeping it alive.
 */
export function observeResize(
  container: HTMLElement,
  render: () => void
): void {
  if (typeof ResizeObserver === 'undefined') return;
  var parent = container.parentElement || container;
  var lastW = parent.clientWidth;
  var ro = new ResizeObserver(function () {
    var newW = parent.clientWidth;
    if (newW && newW !== lastW) {
      lastW = newW;
      ro.disconnect();
      container.style.width = '';
      render();
    }
  });
  ro.observe(parent);
}
